import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface SharedFavListRes {
  favouriteListId: number
  isShared: boolean
  userId: number | null
}

export interface SharedFavouritesListResponseData extends ResponseData {
  data: SharedFavListRes
}
export interface SharedFavouritesListResponse extends AxiosResponse {
  data: SharedFavouritesListResponseData
}

interface SharedFavouritesListParams {
  favouriteListId: string
  isShared?: boolean
}

export interface SharedFavouriteListRequest
  extends Partial<AxiosRequestConfig> {
  params: SharedFavouritesListParams
}

export function updateSharedFavoriteListApi(
  { params }: SharedFavouriteListRequest,
  axiosInstance: AxiosInstance,
): Promise<SharedFavouritesListResponse> {
  const url = `/user/favouritelist/sharedfavourite`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<SharedFavouritesListResponse>
}
